import React from 'react';

interface HtmlDescriptionProps {
  description: string ; 
}

const HtmlDescription: React.FC<HtmlDescriptionProps> = ({ description }) => {
  return (
    <div className="chalet-description" dangerouslySetInnerHTML={{ __html: description }} />
  );
};

export default HtmlDescription;